import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Verified } from "../../../assets/images";
import { formateDateWithTime } from "../../../utils/commonFunctions";
import Avatar from "../CircularAvatar/CircularAvatar";
type AppProps = {
  isApprove?: boolean;
  approved?: boolean;
  isAddComments?: boolean;
  approvalDetails?: any;
  handleApproval: () => void;
  handleToggleCommentsModal?: () => void;
  approveBtnText?: string;
};
const Approve = ({
  isApprove,
  approved,
  handleApproval,
  isAddComments,
  approvalDetails,
  handleToggleCommentsModal,
  approveBtnText,
}: AppProps) => {
  return (
    <div className="card mt-2">
      <div className="card-body">
        <div className="approve-details">
          <div>
            <h6>Approval Details</h6>
            {
              <div>
                {isApprove && (
                  <Button
                    disabled={approved}
                    className="mr-2"
                    onClick={() => {
                      handleApproval();
                    }}
                  >
                    <img src={Verified} alt="verified" />
                    {approved
                      ? "Approved"
                      : approveBtnText
                      ? approveBtnText
                      : "Approve This Entry"}
                  </Button>
                )}
                {isAddComments && (
                  <Button className="btn" onClick={handleToggleCommentsModal}>
                    Add Comment
                  </Button>
                )}
              </div>
            }
          </div>
          <div>
            {approvalDetails?.length > 0 && <p>Previously approved by</p>}
            <div style={{ display: "flex", gap: "3%" }}>
              {approvalDetails?.length > 0 &&
                approvalDetails?.map((approvalProfile: any) => {
                  let fullName = approvalProfile?.user_name;
                  return (
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 250, hide: 250 }}
                      overlay={
                        <Tooltip id="button-view-open-item">
                          {fullName}
                          <br></br>
                          approved on{" "}
                          {formateDateWithTime(approvalProfile?.approved_at)}
                        </Tooltip>
                      }
                    >
                      <span>
                        {" "}
                        <Avatar
                          name={fullName}
                          image={approvalProfile?.profile_pic?.file_url}
                        />
                      </span>
                    </OverlayTrigger>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Approve;
